import { easeInOutQuad as DEFAULT_EASING } from './easings';

let scrollAnimatorTimeInSeconds = 0,
    scrollAnimatorTo = 0,
    scrollAnimatorFrom = 0,
    scrollAnimatorCurrentIteration = 0,
    scrollAnimatorTotalIterations = 0,
    scrollAnimatorTotalDistance = 0;
    
let easingFunction = null,
    callback = null,
    originalLazyLoadMode = 3;

const DEFAULT_DURATION = .5;
        
function smoothScrollHelper (event) {
    if (scrollAnimatorTotalIterations > scrollAnimatorCurrentIteration) {
        const newScrollPos = easingFunction(scrollAnimatorCurrentIteration, scrollAnimatorFrom, scrollAnimatorTotalDistance, scrollAnimatorTotalIterations);
        scrollAnimatorCurrentIteration++;
            
        window.scrollTo(0, newScrollPos);
        requestAnimationFrame(smoothScrollHelper);
    }
        
    else {
        window.scrollTo(0, scrollAnimatorTo);
        window.lazySizesConfig.loadMode = originalLazyLoadMode;
        window.lazySizes.loader.checkElems();
        if (typeof callback === "function") callback();
    }
}

/**
 * @function smoothScrollIntoView
 * @memberof Promega.Util
 * @description Smoothly scrolls the given element into view and optionally updates the URL hash.
 * @param {HTMLElement} elem The HTML element to scroll into view.
 * @param {String} time The duration of the animation.
 * @param {JSON} [options] Options to configure the scrolling animation.
 * @param {Number} options.offset A number of pixels by which to offset the scroll destination. May be either positive or negative.
 * @param {Boolean} options.updateHash If true, updates the browser's URL to contain a hash for the destination anchor.
 * @param {Function} options.callback A function to call upon completion of the scrolling animation.
 * @param {Function} options.easingFunction An easing function to use. Ease in/out quad is used by default if this option is not included.
 */

export default function smoothScrollIntoView (elem, time, options) {
    scrollAnimatorTimeInSeconds = (typeof time === "number" && time > 0 && time != Infinity) ? time / 1000 : DEFAULT_DURATION,
    scrollAnimatorTo = 0,
    scrollAnimatorFrom = 0,
    scrollAnimatorCurrentIteration = 0,
    scrollAnimatorTotalIterations = 0,
    scrollAnimatorTotalDistance = 0;
    callback = null;
    easingFunction = DEFAULT_EASING;
        
    if (elem !== null) {
        scrollAnimatorTo = Math.floor(elem.getBoundingClientRect().top + window.pageYOffset);
        if (options && options.offset !== undefined) {
            const parsedOffset = parseInt(options.offset, 10);
            if (!isNaN(parsedOffset)) scrollAnimatorTo += parsedOffset;
        }
        scrollAnimatorFrom = window.pageYOffset;
            
        scrollAnimatorCurrentIteration = 0;
        scrollAnimatorTotalIterations = scrollAnimatorTimeInSeconds * 60;
        scrollAnimatorTotalDistance = scrollAnimatorTo - scrollAnimatorFrom;
            
        if (options) {
            if (options.updateHash) {
                if (elem.name || elem.href || elem.id) location.hash = elem.name || elem.href || elem.id;
            }
            if (options.callback && typeof options.callback === "function") callback = options.callback;
            if (options.easingFunction && typeof options.easingFunction === "function") easingFunction = options.easingFunction;
        }
            
        if (scrollAnimatorTo != scrollAnimatorFrom && scrollAnimatorTimeInSeconds > 0) {
            originalLazyLoadMode = window.lazySizesConfig.loadMode;
            window.lazySizesConfig.loadMode = 0;
            requestAnimationFrame(smoothScrollHelper);
        }
        else if (typeof callback === "function") callback();
    }
}
